/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
	CompanyResponseDto,
	CompanySubscribeVerifyResponseDto,
	CompanyUpdateRequestDto,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Company<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags /company
	 * @name DoPostCompanySubscribe
	 * @summary 업체 > 구독
	 * @request POST:/company/subscribe
	 * @secure
	 * @response `200` `string` OK
	 * @response `404` `string` 결제 플랜 확인
	 * @response `409` `string` 이미 등록된 카드
	 * @response `500` `string` 서버 오류
	 */
	doPostCompanySubscribe = (
		data: CompanySubscribeVerifyResponseDto,
		params: RequestParams = {},
	) =>
		this.http.request<string, string>({
			path: `/company/subscribe`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /company
	 * @name DoDeleteCompanySubscribe
	 * @summary 업체 > 구독 취소
	 * @request DELETE:/company/subscribe
	 * @secure
	 * @response `200` `string` OK
	 * @response `500` `string` 서버 오류
	 */
	doDeleteCompanySubscribe = (params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/company/subscribe`,
			method: "DELETE",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description 업체의 상세 정보
	 *
	 * @tags /company
	 * @name DoGetCompany
	 * @summary 업체 상세 (변경: 2023.08, maxApp 추가)
	 * @request GET:/company
	 * @secure
	 * @response `200` `CompanyResponseDto` OK
	 * @response `400` `CompanyResponseDto` 입력 데이터 확인
	 */
	doGetCompany = (params: RequestParams = {}) =>
		this.http.request<CompanyResponseDto, CompanyResponseDto>({
			path: `/company`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description 이메일 또는 업체명 변경
	 *
	 * @tags /company
	 * @name DoPatchCompany
	 * @summary 업체 수정 > 이메일 또는 업체명 변경
	 * @request PATCH:/company
	 * @secure
	 * @response `200` `CompanyResponseDto` OK
	 * @response `400` `CompanyResponseDto` 입력 데이터 확인
	 */
	doPatchCompany = (data: CompanyUpdateRequestDto, params: RequestParams = {}) =>
		this.http.request<CompanyResponseDto, CompanyResponseDto>({
			path: `/company`,
			method: "PATCH",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /company
	 * @name DoGetCompanySubscribePaymentPlanId
	 * @summary 업체 > 구독 > 정기결제 (업체결제) unique kye 발급
	 * @request GET:/company/subscribe/{paymentPlanId}
	 * @secure
	 * @response `200` `string` OK
	 * @response `404` `string` 결제 플랜 확인
	 * @response `500` `string` 서버 오류
	 */
	doGetCompanySubscribePaymentPlanId = (
		paymentPlanId: number,
		params: RequestParams = {},
	) =>
		this.http.request<string, string>({
			path: `/company/subscribe/${paymentPlanId}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /company
	 * @name DoGetCompanySubscribeAppIdPaymentPlanId
	 * @summary 업체 > 구독 > 정기결제 (앱별결제) unique kye 발급 (변경: 2023.08)
	 * @request GET:/company/subscribe/{paymentPlanId}/{appId}
	 * @secure
	 * @response `200` `string` OK
	 * @response `404` `string` 결제 플랜 확인
	 * @response `500` `string` 서버 오류
	 */
	doGetCompanySubscribeAppIdPaymentPlanId = (
		paymentPlanId: number,
		appId: number,
		params: RequestParams = {},
	) =>
		this.http.request<string, string>({
			path: `/company/subscribe/${paymentPlanId}/${appId}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
}
